module.exports = __webpack_public_path__ + "static/media/sales.f32b6b94.png";